import { RenderMediaContent } from "src/components/RenderMediaContent"

import real_time_inspector from '../../assets/setup/real_time_inspector.png';

export const RealTimeInspector: React.FC = () => {
    return (
        <div className="flex flex-col justify-center gap-y-4">
            <p>View and filter all your SAMMI buttons in real time, including the ones inside encrypted decks.</p>
            <p><strong>Features:</strong></p>
            <ul className="list-disc list-inside">
                <li>View all buttons in a single, scrollable list.</li>
                <li>Filter buttons by their deck name, deck status, trigger type, trigger message (partial matches allowed), or group ID.</li>
                <li>By clicking on 'Edit Button', you can modify the buttons directly in SAMMI Core.</li>
            </ul>
            <RenderMediaContent src={real_time_inspector} width={"800px"} />

        </div>
    );
};
